export const PREFECTURE_OPTIONS = [
  '北海道',
  '青森県',
  '岩手県',
  '宮城県',
  '秋田県',
  '山形県',
  '福島県',
  '茨城県',
  '栃木県',
  '群馬県',
  '埼玉県',
  '千葉県',
  '東京都',
  '神奈川県',
  '新潟県',
  '富山県',
  '石川県',
  '福井県',
  '山梨県',
  '長野県',
  '岐阜県',
  '静岡県',
  '愛知県',
  '三重県',
  '滋賀県',
  '京都府',
  '大阪府',
  '兵庫県',
  '奈良県',
  '和歌山県',
  '鳥取県',
  '島根県',
  '岡山県',
  '広島県',
  '山口県',
  '徳島県',
  '香川県',
  '愛媛県',
  '高知県',
  '福岡県',
  '佐賀県',
  '長崎県',
  '熊本県',
  '大分県',
  '宮崎県',
  '鹿児島県',
  '沖縄県',
] as const;

export const BOTTOM_MENU_ITEMS = [
  {
    key: 3,
    target: '_blank',
    text: 'Pro Doctorsについて',
    to: 'https://med-pro.jp/lp.dr/',
  },
  {
    key: 4,
    target: '_blank',
    text: '運営会社',
    to: 'https://www.wantedly.com/companies/company_1758293',
  },
  {
    key: 5,
    target: '_blank',
    text: '掲載したい医療機関の方',
    to: 'https://med-pro.jp/media.dr/clp/hp/',
  },
  {
    key: 6,
    target: '_blank',
    text: '利用規約',
    to: 'https://med-pro.jp/media.dr/prodoctors_termsofservice/',
  },
  {
    key: 7,
    target: '_blank',
    text: 'お問い合わせ',
    to: 'https://docs.google.com/forms/d/e/1FAIpQLSfStJDKdx1mouZ5ncVftqaS4gfBbUvOtahJpbBoCfEZAYwB5Q/viewform?usp=send_form',
  },
  {
    key: 8,
    target: '_blank',
    text: 'プライバシーポリシー',
    to: 'https://med-pro.jp/media.dr/en_privacypolicy/',
  },
];

export const SIDE_BAR_JOB_MENU_ITEMS = [
  { isDisabled: true, key: 1, path: '/', text: '仕事一覧' },
  { isDisabled: true, key: 2, path: '/', text: 'メッセージ一覧' },
  { isDisabled: true, key: 3, path: '/chats', text: '通知一覧' },
];

export const SIDE_BAR_SYSTEM_MENU_ITEMS_NO_LOGIN = [
  {
    isDisabled: false,
    key: 1,
    path: 'https://med-pro.jp/media.dr/clp/hp/',
    target: '_blank',
    text: '掲載希望の方へ',
  },
];

export const SIDE_BAR_SYSTEM_MENU_ITEMS = [
  {
    isDisabled: false,
    key: 1,
    path: 'https://med-pro.jp/lp.dr/',
    target: '_blank',
    text: 'Pro Doctorsについて',
  },
  {
    isDisabled: false,
    key: 2,
    path: 'https://docs.google.com/forms/d/e/1FAIpQLSfStJDKdx1mouZ5ncVftqaS4gfBbUvOtahJpbBoCfEZAYwB5Q/viewform?usp=send_form',
    target: '_blank',
    text: 'お問い合わせ',
  },
];

/*
  localStorage, sessionStorage を使う場合はここに key を追加
  重複しないように一元管理
*/
export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'accessToken',
  AFTER_LOGIN_ROUTE: 'afterLoginRoute',
  FINGERPRINT: 'fingerprint', // 予約
  REFRESH_TOKEN: 'refreshToken', // 予約
  USER_ID: 'userId',
};

export const ERROR_MESSAGE = {
  EMAIL_NOT_FOUND:
    '入力されたメールアドレスの会員情報が見つかりません。間違ったメールアドレスを入力されていないかご確認ください。',
  INVALID_USER_ID: 'ログアウトします',
  INVALID_USER_TYPE: 'ProDoctorsの医療機関側のURLで再度お試しください。',
  TOKEN_EXPIRED: '認証の有効期限が切れました。再ログインしてください。',
};
